import i18nRouteMeta from '@/app-core/mixins/i18n/i18nRouteMeta'
import {toLocaleTitleCase, toLocaleUpperCase} from '@/app-core/lib/helpers'
import {clone} from '@/app-core/lib/utils/helper'
import DataEventEnum from '@/app-core/lib/services/enum/DataEventEnum'

export default {
  name      : 'Account',
  components: {},
  directives: {},
  mixins    : [i18nRouteMeta],
  props     : {},
  enums     : {},
  dataStore : {},
  data() {
    return {
      updateKey: new Date().getTime()
    }
  },
  computed: {
    customerInfo() {
      return clone(this.user.Info)
    },
    items() {
      return [
        {
          text  : toLocaleTitleCase(this.$t('Account.PersonalInfo.Title')),
          to    : 'AccountPersonalInfo',
          active: true
        },
        {
          text  : toLocaleTitleCase(this.$t('Account.Addresses.Title')),
          to    : 'AccountAddresses',
          active: this.AppConfig.Marketplace.SupportsDelivery
        },
        {
          text  : toLocaleTitleCase(this.$t('Account.OrderHistory.Title')),
          to    : 'AccountOrderHistory',
          active: true
        },
        {
          text  : toLocaleTitleCase(this.$t('Account.Settings.Title')),
          to    : 'AccountSettings',
          active: true
        }
      ]
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
    this.$bus.$on(DataEventEnum.ACCOUNT_UPDATE_PUSH, this.onAccountUpdatePush)
    this.$bus.$on(DataEventEnum.EVENT, this.onPushEvent)
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
    this.$bus.$off(DataEventEnum.ACCOUNT_UPDATE_PUSH, this.onAccountUpdatePush)
    this.$bus.$off(DataEventEnum.EVENT, this.onPushEvent)
  },
  destroyed() {
  },
  methods: {
    toLocaleUpperCase,
    clone,

    onPushEvent(data) {
      if (data?.Event === DataEventEnum.PUSH_NOTIFICATION_PERMISSION_CHANGE || data?.Event === DataEventEnum.PUSH_USER_SUBSCRIPTION_CHANGE) this.onAccountUpdatePush()
    },

    onAccountUpdatePush() {
      this.updateKey = new Date().getTime()
    }
  }
}
